exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{body,html{width:8.5in!important;height:11in!important}@page{size:8.5in 11in;margin-top:.35in;margin-left:.5in;margin-right:.5in;margin-bottom:.35in}#teacher-info .item-info>li{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;border-bottom:0}#teacher-info .item-info li strong{-webkit-box-flex:0;-ms-flex:0 0 180px;flex:0 0 180px;text-align:right;padding-right:1.5em}#teacher-info .item-info li span{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.main-footer,.sidebar,.site-header,div.breadcrumbs,div.contentBox{display:none}#teacher-info .item-expertise{-webkit-column-break-inside:auto;break-inside:auto}#container,#content,#main,#sprflt,#wrap{border:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /node_modules/css-loader?minimize!/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0512cc6e","scoped":false,"hasInlineConfig":true}!/node_modules/sass-loader/lib/loader.js!/node_modules/vue-loader/lib/selector.js?type=styles&index=0!/resources/js/pages/teacher.vue
// module id = EXGZ
// module chunks = 3